let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cmcKh"), load("ktyyJ")]).then(() => parcelRequire('1VYG6'));